import convertValue from './convertValue';
import getUnit from './getUnit';
export default function (fields) {
  var ret = {};
  fields.forEach(function (field) {
    var commodityCode = field.code;
    var commodity = {};
    var properties = field.properties;

    for (var propertyCommodityCode in properties) {
      var info = properties[propertyCommodityCode];
      var propertyUnit = getUnit(info);
      commodity[propertyCommodityCode] = getValueList(info.values, propertyUnit, info.conversion);
    }
    ret[commodityCode] = commodity;
  });
  return ret;
}

function getValueList() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var propertyUnit = arguments[1];
  var conversion = arguments[2];

  values = convertValue({ values: values, propertyUnit: propertyUnit, conversion: conversion });
  return values.map(function (value) {
    if (value.valueType === 'range_float') {
      return value;
    } else {
      return {
        globalKey: value.globalKey || '',
        text: value.name,
        value: value.value,
        tips: value.remark || ''
      };
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/common-cpq-constraint/es/convertRestriction/convertToComponents.js
// module id = 171
// module chunks = 0